<div class="modal-wrapper" [formGroup]="form">
  <nz-radio-group formControlName="selectedCompany" role="radiogroup" aria-label="Seleziona l'azienda">
    @for (company of companies; track company) {
      <label nz-radio [nzValue]="company.companyId" aria-label="{{ company.name }}">
        {{ company.name }}
      </label>
    }
  </nz-radio-group>
  <div class="buttons">
    <ds-button class="confirm" [width]="'small'" [text]="'modal-companies.button' | translate" [isDisabled]="!form.value.selectedCompany" (click)="confirmSelection()"></ds-button>
  </div>
</div>
